import { Alert, Box, LinearProgress, Paper, Stack } from '@mui/material';
import Grid from '@mui/material/Grid';
import LanguageSelector from 'components/selectors/LanguageSelector';
import { apiSlice, useLogoutMutation, usePostExternalDeviceFitbitMutation } from 'features/api/apiSlice';
import { localLogout } from 'features/auth/authSlice';
import useProvideClient from 'hooks/client/useProvideClient';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { dispatch } from 'store';

export default function FitbitPage() {
  const clientProvider = useProvideClient();

  const [postExternalDeviceFitbit] = usePostExternalDeviceFitbitMutation();
  const [searchParams] = useSearchParams();

  const [isPostingFitbitDevice, setIsPostingFitbitDevice] = useState(false);
  const [alert, setAlert] = useState<{ type: 'success' | 'error'; message: string } | null>(null);

  const [logout] = useLogoutMutation();
  const handleLogout = async () => {
    try {
      await logout().unwrap();
      dispatch(localLogout());
      dispatch(apiSlice.util.resetApiState());
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');

    if (code && state) {
      setIsPostingFitbitDevice(true);
      postExternalDeviceFitbit({ postFitbitDevice: { code, state } })
      .unwrap()
      .then((result) => {
        setIsPostingFitbitDevice(false);
        setAlert({
          type: 'success',
          message: t("fitbit_device_registered_successfully.", "Fitbit device registered successfully.")
        });
      })
      .catch((error) => {
        setIsPostingFitbitDevice(false);
        setAlert({
          type: 'error',
          message: error.data?.message || "Unknown error"
        });
      })
      .finally(() => {
        handleLogout()
      });
    }
  }, [postExternalDeviceFitbit, searchParams]);

  return (
    <Grid container component="main" sx={{ height: '100vh' }}>
      <Grid
        item
        xs={false}
        sm={4}
        md={6}
        sx={{
          backgroundImage: `url("data:image/svg+xml;base64,${btoa(clientProvider.client.backgroundLoginLeft)}")`,
          backgroundRepeat: 'repeat',
          backgroundSize: 'inherit',
          backgroundPosition: 'center'
        }}
      />
      <Grid item xs={12} sm={8} md={6} component={Paper} elevation={6} square sx={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}>
        <Stack sx={{ position: "fixed", top: '2%', right: '1%' }}>
          <LanguageSelector />
        </Stack>
        <Stack
          width='100%'
          sx={{
            my: 8,
            mx: 4,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Box component="img" src={clientProvider.client.logo} maxWidth='30%' sx={{ my: 2 }} />

          {isPostingFitbitDevice ? (
            <LinearProgress sx={{ width: "60%" }} />
          ) : (
            <Stack component="form" noValidate sx={{ mt: 1, height: '100%', width: '40%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {alert && (
                <Alert sx={{ width: '100%', my: 2 }} severity={alert.type}>
                  {alert.message}
                </Alert>
              )}
            </Stack>
          )}
        </Stack>
      </Grid>
    </Grid>
  );
}